import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../../../schoolselector/schoolselectorservice.service";
import { DataService_MultiStationVisiteeMaintenance } from "../../shared/data.service";

@Component({
	selector: "app-ms-visitee-batch-export",
	templateUrl: "./ms-visitee-batch-export.component.html",
	styleUrls: ["./ms-visitee-batch-export.component.css"],
})
export class MsVisiteeBatchExportComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private selectService: SchoolselectorService,
		private visitorService: DataService_MultiStationVisiteeMaintenance
	) {}

	ngOnInit(): void {
		this.loadFormatOptions();
		this.loadPersonType();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	///////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////

	subscription: any;

	LoadingFormatOptions: boolean = true;
	SelectedFormatOption: any;
	lstFormatOptions: any = [];

	School: any;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "All Schools";

	LoadingPersonType: boolean = true;
	SelectedPersonType: any;
	lstPersonType: any = [];

	ActiveOptionID: any = 1;
	lstActiveOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	HasEmailOptionID: any = -1;
	lstHasEmailOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Has Email On Record",
		},
		{
			ID: 0,
			Desc: "No Email",
		},
	];

	HasPhoneNbrOptionID: any = -1;
	lstHasPhoneNbrOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Has Phone Number On Record",
		},
		{
			ID: 0,
			Desc: "No Phone Number",
		},
	];

	AlreadyVisiteeOptionID: any = -1;
	lstAlreadyVisiteeOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Already a Visitee",
		},
		{
			ID: 0,
			Desc: "Not Signed Up as Visitee",
		},
	];

	IsProcessing: boolean = false;

	errorMessage: string = "";

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////////

	loadFormatOptions() {
		this.LoadingFormatOptions = true;

		var result = this.visitorService.ExportFormatOptionSelectList();
		result.subscribe(
			(response) => {
				this.lstFormatOptions = response;

				this.SelectedFormatOption = this.lstFormatOptions[0];
				this.LoadingFormatOptions = false;
			},
			(error) => {
				this.LoadingFormatOptions = false;
			}
		);
	}

	loadPersonType() {
		this.LoadingPersonType = true;

		var result = this.visitorService.StaffPersonTypeSelectList();
		result.subscribe(
			(response) => {
				this.lstPersonType = response;

				this.lstPersonType.unshift({
					PersonTypeID: -1,
					PersonTypeDesc: "Any",
				});

				this.SelectedPersonType = this.lstPersonType[0];
				this.LoadingPersonType = false;
			},
			(error) => {
				this.LoadingPersonType = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////
	onExport() {
		this.IsProcessing = true;

		//
		// Get data from WS
		//

		var result = this.visitorService.ExportSelectList(
			this.School.SchoolID,
			this.AlreadyVisiteeOptionID,
			this.SelectedPersonType.PersonTypeID,
			this.ActiveOptionID,
			this.HasEmailOptionID,
			this.HasPhoneNbrOptionID,
			this.SelectedFormatOption.ID
		);
		result.subscribe(
			(response) => {
				this.IsProcessing = false;

				var Data: any = response[0];

				if (Data != undefined) {
					var a = document.createElement("a"); //Create <a>

					var FileName = "Visitee_Export_";

					if (this.School.SchoolID > 0) {
						FileName += this.School.SchoolNumber;
					} else {
						FileName += this.School.SchoolName;
					}

					//Text tab
					if (this.SelectedFormatOption.ID == 1) {
						a.href = "data:text/plain;base64," + response[0];
						a.download = FileName + ".txt";
						a.click(); //Downloaded file
					}
					//Text comma
					else if (this.SelectedFormatOption.ID == 2) {
						a.href = "data:text/plain;base64," + response[0];
						a.download = FileName + ".txt";
						a.click(); //Downloaded file
					}
					//CSV
					else if (this.SelectedFormatOption.ID == 3) {
						a.href = "data:text/csv;base64," + response[0];
						a.download = FileName + ".csv";
						a.click(); //Downloaded file
					}
				} else {
					this.errorMessage = "Error Exporting Data";
				}
			},
			(error) => {
				this.IsProcessing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////////
	onSchoolChange(school) {
		this.School = school;
	}
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.LoadingFormatOptions == true || this.LoadingPersonType == true || this.IsProcessing == true;
	}
	///////////////////////////////////////////////////////////////////////////
}
